module.exports = __webpack_public_path__ + "media/src/assets/Images/Store-d58ee399e27da2677264411e394b6b10.svg";